/** @jsxImportSource theme-ui */
import ConfigurationSchema from '@/containers/widget/ConfigurationSchema';

const WidgetConfigurationSchemaPage = () => <ConfigurationSchema />;

export default WidgetConfigurationSchemaPage;
